import {
  LANGUAGE_CLOSE_POPUP,
  LANGUAGE_OPEN_POPUP,
  LANGUAGE_CHANGE_SUCCESS,
} from "./types";

export const languageClosePopup = () => {
  return {
    type: LANGUAGE_CLOSE_POPUP,
  };
};

export const languageOpenPopup = () => {
  return {
    type: LANGUAGE_OPEN_POPUP,
  };
};

export const languageChangeSuccess = () => {
  return {
    type: LANGUAGE_CHANGE_SUCCESS,
  };
};
